import { fileApi } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

/**
 * RTK Query API slice for media operations
 * Handles file and folder management, drag-and-drop, and media library operations
 */
export const mediaApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getMedia: builder.query({
      query: ({ directoryId, isIncarnated }) => ({
        url: fileApi(),
        method: 'POST',
        body: { method: 'listDirectory', data: { directoryId } },
        suppressGenericErrorToast: true,
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { directoryId }) => [
        { type: 'Media', id: directoryId },
        { type: 'Directory', id: directoryId },
      ],
    }),
    createDirectory: builder.mutation({
      query: ({ directoryId, name }) => ({
        url: fileApi(),
        method: 'POST',
        body: { method: 'createDirectory', data: { directoryId, name } },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: (result, error, { directoryId }) => [
        { type: 'Directory', id: directoryId },
        { type: 'Media', id: directoryId },
      ],
    }),
    deleteDirectory: builder.mutation({
      query: (id) => ({
        url: fileApi(),
        method: 'POST',
        body: { method: 'deleteDirectory', data: { id } },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Media', 'Directory'],
    }),
    moveFile: builder.mutation({
      query: ({ id, directoryId }) => ({
        url: fileApi(),
        method: 'POST',
        body: { method: 'move', data: { id, directoryId } },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Media', 'Directory'],
    }),
    deleteFile: builder.mutation({
      query: ({ id }) => ({
        url: fileApi(),
        method: 'POST',
        body: { method: 'delete', data: { id } },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Media'],
    }),
    getFileCourseInfo: builder.query({
      query: ({ id }) => ({
        url: fileApi(),
        method: 'POST',
        body: { method: 'getFileInfo', data: { id } },
      }),
      transformResponse: (response) => {
        const fileData = response.data && response.data[0];
        return {
          file: fileData,
          courses: fileData?.courses || []
        };
      },
      providesTags: (result, error, { id }) => [{ type: 'Media', id }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMediaQuery,
  useCreateDirectoryMutation,
  useDeleteDirectoryMutation,
  useMoveFileMutation,
  useDeleteFileMutation,
  useGetFileCourseInfoQuery,
} = mediaApi;
